import { logger } from '@/modules/common/logging/logger';

import { PlayMode } from '../store/usePlayStore';
import { IFleetTrackerPlaybackService } from './IFleetTrackerPlaybackService';

export class FleetTrackerPlaybackServiceExceptionDecorator implements IFleetTrackerPlaybackService {
  private decoree: IFleetTrackerPlaybackService;

  constructor(decoree: IFleetTrackerPlaybackService) {
    this.decoree = decoree;
  }

  initializePlayback(startTime: Date, endTime: Date | undefined): void {
    try {
      this.decoree.initializePlayback(startTime, endTime);
    } catch (err) {
      this.logError('initializePlayback', err);
    }
  }

  updateCurrentTime(currentTime: Date): void {
    try {
      this.decoree.updateCurrentTime(currentTime);
    } catch (err) {
      this.logError('updateCurrentTime', err);
    }
  }

  cancelPendingCurrentTimeUpdate(): void {
    try {
      this.decoree.cancelPendingCurrentTimeUpdate();
    } catch (err) {
      this.logError('cancelPendingCurrentTimeUpdate', err);
    }
  }

  changePlayMode(mode: PlayMode, playing: boolean, speed: number): void {
    try {
      this.decoree.changePlayMode(mode, playing, speed);
    } catch (err) {
      this.logError('changePlayMode', err);
    }
  }

  setPlay(playing: boolean): void {
    try {
      this.decoree.setPlay(playing);
    } catch (err) {
      this.logError('setPlay', err);
    }
  }

  setSpeed(speed: number): void {
    try {
      this.decoree.setSpeed(speed);
    } catch (err) {
      this.logError('setSpeed', err);
    }
  }

  seek(time: Date): void {
    try {
      this.decoree.seek(time);
    } catch (err) {
      this.logError('seek', err);
    }
  }

  private logError(methodName: string, err: unknown): void {
    logger.error(`Error in ${methodName}:`, err);
  }
}
